/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["fieldset[_ngcontent-%COMP%]{font-family:sans-serif;border:2px solid!important;background:var(--background-fieldset)!important;border-radius:5px;padding:0 0 5px;margin-bottom:20px}fieldset[_ngcontent-%COMP%]   legend[_ngcontent-%COMP%]{background:var(--background-legend)!important;color:var(--color-legend)!important;padding:5px 10px;font-size:12px;border-radius:5px;box-shadow:0 0 0 5px var(--box-legend)!important;margin-left:20px}"];
export { styles as styles };
